import { useRouter } from 'next/router';

interface PromotionQuery {
  /** 기획전 id */
  id?: string;
  /** 앵커링할 id */
  anchor?: string;
  /** 외부에서 진입시 초기 앵커링 여부 */
  // eslint-disable-next-line camelcase
  anchor_section?: string;
  /** section 정보 */
  section?: string;
}

interface UsePromotionQueryParam {
  isProd: boolean;
  defaultId?: number;
}

interface UsePromotionQueryResponse {
  promotionId: number;
  anchorTargetId?: string;
  anchorSection?: string;
  section: string;
}

export function usePromotionQuery({
  isProd,
  defaultId,
}: UsePromotionQueryParam): UsePromotionQueryResponse {
  const router = useRouter();
  const {
    id,
    section,
    anchor: anchorTargetId,
    anchor_section: anchorSection,
  } = router.query as PromotionQuery;

  // production일경우 정해진 ID만 사용할 수 있으나, stage에서는 QA를 위해 전달받은 id가 있으면 해당 id를 먼저 사용
  // e.g events.stage-web.dailyhou.se/promotion/o-season-week?id=12345 일경우 12345 기획전 사용
  const promotionId = isProd && defaultId ? defaultId : (id ?? defaultId);

  const numericPromotionId = Number(promotionId);
  const validPromotionId =
    !isNaN(numericPromotionId) && numericPromotionId > 0
      ? numericPromotionId
      : (defaultId ?? 0);

  return {
    promotionId: validPromotionId,
    anchorTargetId,
    anchorSection,
    section: section ?? '',
  };
}
